import { BlogPostsListResponse, normalizeBlogPosts } from '@screens/Blog';
import { BlogPostType } from '@screens/Product/model/types/blog';
import { fetchServerData } from '@shared/utils/fetchServerData/fetchServerData';

const getUniqueBlogPosts = (posts: BlogPostType[]) => {
  const postIds = new Set<string>();

  return posts.filter((post) => {
    if (!post.id || postIds.has(post.id)) {
      return false;
    }

    postIds.add(post.id);
    return true;
  });
};

export const getProductPageBlogPosts = async (): Promise<BlogPostType[]> => {
  const response = await fetchServerData<BlogPostType[] | BlogPostsListResponse>('v2/blog/post/product-page');

  return normalizeBlogPosts(response.data);
};

export const getProductBlogPostsByProductId = async (productId: string): Promise<BlogPostType[]> => {
  const params = new URLSearchParams({
    take: '1000',
    skip: '0'
  });
  const response = await fetchServerData<BlogPostType[] | BlogPostsListResponse>(
    `v2/blog/post/by-product/${productId}?${params}`
  );

  return normalizeBlogPosts(response.data);
};

export const getProductBlogPosts = async (productId: string): Promise<BlogPostType[]> => {
  const responses = await Promise.allSettled([getProductBlogPostsByProductId(productId), getProductPageBlogPosts()]);

  return getUniqueBlogPosts(responses.flatMap((response) => (response.status === 'fulfilled' ? response.value : [])));
};
